<span *ngIf="description">{{ description }}</span>
